import { SlideShow } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { RulingNumberSliderV2Css } from './Common.css'
import { rulingNumbers } from '../../components/NumerologyV2/const'
import { BaseNumber } from '../NumerologyV2/Number'
import { EDevice } from '../../containers/MainLayout'
import AppContext from '../../context/AppContext'
interface IProps {
	rulingNumber: string | number | null
}

export function RulingNumberSlider({ rulingNumber }: IProps) {
	const { breakpoint } = useContext(AppContext)
	const router = useRouter()
	const firstNumber = 2
	const [loading, setLoading] = useState(true)
	let eventTimeout: ReturnType<typeof setTimeout> | null
	let currentIndex: number
	//ruling number not change => using custom debounce

	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 500);
	}, [])

	const onChangeNumber = (number: number) => {
		if (number === 10) {
			return 22
		}
		return number + firstNumber
	}
	const onReverseDefaultIndex = (rulingNumber: number) => {
		if (rulingNumber === 22) {
			return 10
		}
		return rulingNumber - firstNumber
	}
	const handleEvent = (index: number) => {
		if (eventTimeout) {
			clearTimeout(eventTimeout)
			eventTimeout = null
		}
		currentIndex = index
		const getLocationBySyncView = () => {
			if (currentIndex !== index) return
			router.replace({
				pathname: router.pathname,
				query: {
					rulingNumberId: onChangeNumber(index)
				}
			})
			return
		}
		eventTimeout = setTimeout(getLocationBySyncView, 1000)
	}
	const slideShowRef = useRef<JSX.Element>(
		<SlideShow
			id='Slider-test-2'
			slides={{ elementPerView: 5 }}
			pagination={{
				defaultPage: onReverseDefaultIndex(Number(rulingNumber)),
				activeClassName: 'section__slider-active',
				onPageChange: (currentIndex) => {
					handleEvent(currentIndex)
				},
				type: 'whiteArrowOnly'
			}}
			container={{
				style: { width: '100%', display: 'flex', alignItems: 'center' }
			}}
		>
			{rulingNumbers.map((elm, i) => {
				return (
					<div className={`section__slider-item`} key={i}>
						<BaseNumber number={elm.number} />
					</div>
				)
			})}
		</SlideShow>
	)
	const slideShowMobileRef = useRef<JSX.Element>(
		<SlideShow
			id='Slider-test-2'
			slides={{ elementPerView: 3 }}
			pagination={{
				defaultPage: onReverseDefaultIndex(Number(rulingNumber)),
				activeClassName: 'section__slider-active',
				onPageChange: (currentIndex) => {
					handleEvent(currentIndex)
				},
				type: 'whiteArrowOnly'
			}}
			container={{
				style: { width: '100%', display: 'flex', alignItems: 'center' }
			}}
		>
			{rulingNumbers.map((elm, i) => {
				return (
					<div className={`section__slider-item`} key={i}>
						<BaseNumber number={elm.number} />
					</div>
				)
			})}
		</SlideShow>
	)

	return (
		<RulingNumberSliderV2Css className={loading ? "" : "visible"}>
			{breakpoint === EDevice.MOBILE
				? slideShowMobileRef.current
				: slideShowRef.current}
		</RulingNumberSliderV2Css>
	)
}
export default React.memo(RulingNumberSlider)
